
























































































































































import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter } from 'vivat';

import deliveryOption from '@/table/deliveryNote/delivery';
import useDeliveryNoteStatus from '@/useDeliveryNote';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDownloadReport from '@/useDownloadReport';
import useAuth from '@/useAuth';

import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import PanelWithDriverInformation from '@/components/DeliveryNote/PanelWithDriverInformation.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import CommonModalWithReasonSelector from '@/components/DeliveryNote/CommonModalWithReasonSelector.vue';
import ViewImageModal from '@/components/ViewImageModal.vue';

import updateDeliveryStatus from '@/gql/delivery/updateDeliveryStatus.gql';
import getDeliveryNote from '@/gql/deliveryNote/getDeliveryNote.gql';
import updateDeliveryNote from '@/gql/deliveryNote/updateDeliveryNote.gql';

const SCROLL_OFFSET = 196;

const DeliveryNoteInformation = defineComponent({
  components: {
    CommonDeliveryStatusSelect,
    CommonModalWithPreset,
    CommonPanelWithExpandable,
    PanelWithDriverInformation,
    ViewDeliveryMarkerModal,
    CommonModalWithReasonSelector,
    ViewImageModal,
  },
  setup() {
    const { me } = useAuth();
    const { route, router } = useRouter();
    const { getPDFReport } = useDownloadReport();
    const { farthestDeliveryDistanceIndex, distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();
    const {
      translate: deliveryNoteStatusTranslate,
      deliveriesStatusToDeliveryNoteStatus,
      deliveryNoteStatusClassMap,
    } = useDeliveryNoteStatus();
    const toDecimalFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const signatureModal = ref(null);
    const viewImageModal = ref(null);
    const signatureImageUrl: Ref<string> = ref('');

    const isScrolled: Ref<boolean> = ref(false);
    function onScroll() {
      if (window.pageYOffset > SCROLL_OFFSET) isScrolled.value = true;
      else isScrolled.value = false;
    }
    onMounted(() => {
      window.addEventListener('scroll', onScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll);
    });

    // use to open map
    const viewMapModal = ref(null);
    const mapMarkers: Ref<{ delivery: any; lat: number; lng: number }[]> = ref([]);

    // use to get reason when fail to delivery
    const failDeliverySelectModal = ref(null);
    // Fail Reason
    const failReason = reactive([
      { label: 'สินค้าถูกจัดผิดรายการ (โดยคลัง)', active: false },
      { label: 'สินค้าสั่งผิดรายการ (โดยพนง. ขาย)', active: false },
      { label: 'สินค้าสั่งผิดรายการ (โดยลูกค้า)', active: false },
      { label: 'สินค้าผิดคุณภาพ', active: false },
      { label: 'สินค้าชำรุดระหว่างจัดส่ง', active: false },
      { label: 'สินค้าถูกส่งสลับร้าน', active: false },
      { label: 'ลูกค้าปิดทำการ', active: false },
      { label: 'ลูกค้าพื้นที่เต็ม', active: false },
      { label: 'ลูกค้าไม่สะดวกรับสินค้า', active: false },
      { label: 'ลูกค้าตีกลับ', active: false },
      { label: 'รถเสีย', active: false },
      { label: 'รถเกิดอุบัติเหตุ', active: false },
      { label: 'ฝนตก ไม่สามารถลงสินค้าได้', active: false },
      { label: '', active: false },
    ]);

    //
    const deliveryNote: Ref<any> = ref({ deliveries: [] });
    const vehicleTraverse: Ref<any> = ref({ car: {}, stamps: [] });
    const { result: getDeliveryNoteResult, loading } = useQuery(getDeliveryNote, computed(() => ({
      id: route.value.params.id,
    })), () => ({ clientId: 'unauthorize' }));
    const deliveryNoteResult = useResult(getDeliveryNoteResult, {}, (data) => data.deliveryNote);
    watch(() => deliveryNoteResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal) {
        mapMarkers.value = [];
        deliveryNote.value = {
          ...deliveryNoteResult.value,
          deliveries: [...deliveryNoteResult.value?.deliveries, ...deliveryNoteResult.value?.loggedDeliveries].map((delivery: any) => {
            mapMarkers.value.push({
              delivery,
              lat: parseFloat(delivery.lat) >= -90 && parseFloat(delivery.lat) <= 90 ? parseFloat(delivery.lat) : 0,
              lng: parseFloat(delivery.long) >= -180 && parseFloat(delivery.long) <= 180 ? parseFloat(delivery.long) : 0,
            });
            return { ...delivery, hasEdited: false };
          }).sort((a: any, b: any) => a.order - b.order) || [],
        };

        if (deliveryNote.value.locations.length > 0) {
          const [lastPos] = deliveryNote.value.locations;
          vehicleTraverse.value.car = { id: deliveryNote.value.vehicle.id, license: deliveryNote.value.vehicle.license, lastPosition: { lat: lastPos.lat, lng: lastPos.long } };
          vehicleTraverse.value.stamps = deliveryNote.value.locations.map((location: any) => ({
            lat: parseFloat(location.lat) >= -90 && parseFloat(location.lat) <= 90 ? parseFloat(location.lat) : 0,
            lng: parseFloat(location.long) >= -180 && parseFloat(location.long) <= 180 ? parseFloat(location.long) : 0,
          }));
          vehicleTraverse.value.stamps.splice(0, 1);
        } else {
          vehicleTraverse.value.car = { id: -1 };
          vehicleTraverse.value.stamps = [];
        }
      }
    });

    const successUpdateStatusModal = ref(null);
    const updateDeliveryItem = ref({
      id: -1,
      status: 'PENDING',
      failureReason: '',
    });
    const updateDeliveryIndex = ref(-1);
    const updateDeliveryStatusMutation = useMutation(updateDeliveryStatus, () => ({
      variables: {
        id: updateDeliveryItem.value.id,
        input: {
          status: updateDeliveryItem.value.status,
        },
        failureReason: updateDeliveryItem.value.failureReason,
      },
    }));
    const confirmUpdateStatusModal = ref(null);
    function confirmUpdateDeliveryStatus(delivery: any, index: number) {
      updateDeliveryItem.value = delivery;
      updateDeliveryIndex.value = delivery.index;
      if (delivery.status === 'NOT_SUCCESS') (failDeliverySelectModal.value as any).compose(index);
      else (confirmUpdateStatusModal.value as any).compose({ action: 'แก้ไข', entity: 'สถานะ', context: { delivery, index } });
    }
    function updateDeliveryStatusAction(delivery: any, index: number) {
      updateDeliveryItem.value.id = delivery.id;
      updateDeliveryIndex.value = delivery.index;
      (deliveryNote.value as any).deliveries[index].hasEdited = false;
      updateDeliveryStatusMutation.mutate();
    }
    function confirmDone(val: any) {
      const { delivery, index } = val.context;
      updateDeliveryStatusAction(delivery, index);
    }
    function confirmFailed(val: { reason: string; index: number }) {
      const { reason, index } = val;
      updateDeliveryItem.value.failureReason = reason || '';
      updateDeliveryIndex.value = index;
      (failDeliverySelectModal.value as any).close();
      (deliveryNote.value as any).deliveries[index].hasEdited = false;
      updateDeliveryStatusMutation.mutate();
    }

    const errorUpdateStatusModal = ref(null);
    updateDeliveryStatusMutation.onError(() => {
      (errorUpdateStatusModal.value as any).compose();
    });

    const onRowClick = (row: any) => {
      router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    };

    const computedNewDeliveryNoteStatus = computed(() => deliveriesStatusToDeliveryNoteStatus(deliveryNote.value.deliveries));
    const updateDeliveryNoteMutation = useMutation(updateDeliveryNote, () => ({
      variables: {
        id: deliveryNote.value.id,
        input: {
          status: computedNewDeliveryNoteStatus.value,
        },
      },
      refetchQueries: ['getDeliveryNotes', 'getDeliveryNote', 'getDeliveries'],
    }));

    updateDeliveryStatusMutation.onDone(() => {
      if (deliveryNote.value.status !== computedNewDeliveryNoteStatus.value) updateDeliveryNoteMutation.mutate();
      (successUpdateStatusModal.value as any).compose({ action: 'บันทึก', entity: 'สถานะสำเร็จ' });
    });
    function closeSuccessUpdateStatusModal() { (successUpdateStatusModal.value as any).close(); }
    updateDeliveryNoteMutation.onDone((data: any) => {
      deliveryNote.value = {
        ...data.data.updateDeliveryNote,
        deliveries: deliveryNoteResult.value.deliveries?.map((delivery: any, index: number) => ({ ...delivery, hasEdited: (deliveryNote.value as any).deliveries[index].hasEdited })),
      };
    });

    const computedDeliveryArea = computed(() => {
      if (deliveryNote.value.deliveries?.length > 0) {
        const distanceArr: any[] = [];
        const distanceAreaArr: any[] = [];
        // eslint-disable-next-line
        deliveryNote.value.deliveries?.forEach((delivery: any) => {
          // weight += delivery.totalWeight;
          // price += delivery.deliveryFee;
          distanceArr.push(delivery.area?.distanceType || '');
          distanceAreaArr.push(delivery.area);
        });
        const distanceIndex = farthestDeliveryDistanceIndex(distanceArr);
        return distanceIndex > -1 ? distanceAreaArr[distanceIndex] : { code: 'NA', name: '', distanceType: '' };
      }
      return { code: 'NA', name: '', distanceType: '' };
    });

    return {
      me,
      isScrolled,
      loading,

      signatureModal,
      signatureImageUrl,
      viewImageModal,

      translateDistanceType,
      distanceTypeToChipClass,
      toDecimalFormat,

      deliveryNoteStatusTranslate,
      deliveryNoteStatusClassMap,

      deliveryOption,
      deliveryNote,

      successUpdateStatusModal,
      closeSuccessUpdateStatusModal,
      errorUpdateStatusModal,
      updateDeliveryStatusAction,
      confirmUpdateStatusModal,
      confirmUpdateDeliveryStatus,

      onRowClick,
      confirmDone,

      computedNewDeliveryNoteStatus,
      computedDeliveryArea,

      mapMarkers,
      viewMapModal,
      vehicleTraverse,

      // use to get failed delivery reason
      failDeliverySelectModal,
      confirmFailed,

      failReason,

      getPDFReport,
    };
  },
});

export default DeliveryNoteInformation;
